import OrderService from '@/api/services/OrderService';

export const namespaced = true;

export const state = {
  showBasket: false,
  loading: false,
  discount: {
    success: false,
    error: false,
    loading: false,
  },
  removedItem: {
    loading: false,
    error: false,
    itemId: null,
  },
  addItem: {
    loading: false,
    error: false,
    itemId: null,
  },
};

export const mutations = {
  SHOW_BASKET(state, showBasket) {
    state.showBasket = showBasket;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
  DISCOUNTLOADING(state, loading) {
    state.discount.loading = loading;
  },
  DISCOUNTSUCCESS(state, message) {
    state.discount.success = message;
  },
  DISCOUNTERROR(state, message) {
    state.discount.error = message;
  },
  REMOVEITEMLOADING(state, loading) {
    state.removedItem.loading = loading;
  },
  REMOVEITEMERROR(state, error) {
    state.removedItem.error = error;
  },
  REMOVEITEMID(state, itemId) {
    state.removedItem.itemId = itemId;
  },
  ADDITEMLOADING(state, loading) {
    state.addItem.loading = loading;
  },
  ADDITEMERROR(state, error) {
    state.addItem.error = error;
  },
  ADDITEMID(state, itemId) {
    state.addItem.itemId = itemId;
  },
};

export const actions = {
  createLocalOrder({ commit, dispatch }, { cityId, data, discountCode, changingDiscount, onSuccessSetOrder }) {
    changingDiscount ? commit('DISCOUNTLOADING', true) : commit('LOADING', true);
    let products = [];
    data?.forEach((productDetails) => {
      products.push({
        productId: productDetails.productId,
        children: productDetails.connector
          ? [
              {
                productId: productDetails.connector,
              },
              ...productDetails.otherProductIds
                .filter((productId) => productId)
                .map((productId) => ({
                  productId,
                })),
            ]
          : null,
        petId: null,
        personalization: productDetails.personalize?.selected
          ? { name: productDetails.personalize.name, phone: productDetails.personalize.phone }
          : null,
        designExports: productDetails.designExports
          ? { tagFront: productDetails.designExports?.tagFront, laserFront: productDetails.designExports?.laserFront }
          : null,
        keyChain: productDetails.keyChain,
      });
    });
    return new Promise((resolve, reject) =>
      OrderService.temporaryOrder(cityId, products, discountCode)
        .then((response) => {
          if (onSuccessSetOrder) commit('order/SET_ORDER', response, { root: true });
          commit('order/SET_LOCAL_ITEMS', data, { root: true });
          changingDiscount ? commit('DISCOUNTSUCCESS', discountCode ? 'Successfully Applied.' : 'Successfully Removed.') : null;
          resolve(response);
        })
        .catch((error) => {
          if (changingDiscount) {
            commit('DISCOUNTSUCCESS', '');
            if (error.message && error.message.length && error.message[0].message) {
              commit('DISCOUNTERROR', error.message[0].message);
            } else {
              commit('DISCOUNTERROR', 'Uhoh! Something went wrong.');
            }
          } else {
            const notification = {
              type: 'danger',
              message: error?.message?.[0]?.message,
            };
            dispatch('notification/add', notification, { root: true });
          }

          reject(error);
        })
        .finally(() => (changingDiscount ? commit('DISCOUNTLOADING', false) : commit('LOADING', false)))
    );
  },
  applyDiscount({ commit, dispatch }, { orderId, code }) {
    commit('DISCOUNTLOADING', true);
    commit('DISCOUNTSUCCESS', 'Applying Discount...');
    OrderService.applyDiscount(orderId, code)
      .then((response) => {
        commit('order/SET_ORDER', response, { root: true });
        commit('DISCOUNTLOADING', false);
        commit('DISCOUNTERROR', '');
        commit('DISCOUNTSUCCESS', 'Successfully Applied.');
        dispatch('notification/notifySuccess', { message: 'Discount successfully applied.' }, { root: true });
        commit('SHOW_BASKET', true);
        return Promise.resolve();
      })
      .catch((error) => {
        error.location = 'applyDiscount';
        console.error(error);
        commit('DISCOUNTLOADING', false);
        commit('DISCOUNTSUCCESS', '');
        if (error?.message?.[0].message) {
          dispatch('notification/notifyFailure', { message: error.message[0].message, options: { dismissSecs: 15 } }, { root: true });
          commit('DISCOUNTERROR', error?.message?.[0].message);
        } else {
          dispatch('notification/notifyFailure', { message: 'Uhoh! Something went wrong.', options: { dismissSecs: 15 } }, { root: true });
          commit('DISCOUNTERROR', 'Uhoh! Something went wrong.');
        }
        return Promise.reject();
      });
  },
  removeDiscount({ commit }, { orderId }) {
    commit('DISCOUNTLOADING', true);
    OrderService.removeDiscount(orderId)
      .then((response) => {
        commit('order/SET_ORDER', response, { root: true });
        commit('DISCOUNTLOADING', false);
        commit('DISCOUNTERROR', '');
        commit('DISCOUNTSUCCESS', 'Successfully Removed.');
        commit('SHOW_BASKET', true);
      })
      .catch((error) => {
        commit('DISCOUNTLOADING', false);
        commit('DISCOUNTSUCCESS', false);
        if (error?.message?.[0].message) {
          commit('DISCOUNTERROR', error?.message?.[0].message);
        } else {
          commit('DISCOUNTERROR', 'Uhoh! Something went wrong.');
        }
      });
  },
  removeItemOrPersonalization(
    { commit, dispatch, rootState, rootGetters },
    { vm, orderId, itemId, personalization, data, discountCode, changingDiscount, productId, quantity }
  ) {
    if (productId && quantity > 1) {
      return new Promise((resolve, reject) =>
        dispatch('removeItemsByProduct', {
          vm,
          orderId,
          itemId,
          personalization,
          data,
          discountCode,
          changingDiscount,
          productId,
          quantity,
        })
          .then(resolve)
          .catch(reject)
      );
    }
    commit('REMOVEITEMLOADING', true);
    commit('REMOVEITEMID', itemId);
    const dispatchAction = () =>
      new Promise((resolve, reject) => {
        rootState?.orderId || orderId
          ? OrderService[!personalization ? 'removeItem' : 'removePersonalization']?.(orderId, itemId).then(resolve).catch(reject)
          : dispatch('createLocalOrder', { cityId: vm.cityId, data, discountCode, changingDiscount }).then(resolve).catch(reject);
      });
    return new Promise((resolve, reject) =>
      dispatchAction()
        .then((response) => {
          commit('order/SET_ORDER', response, { root: true });
          commit('REMOVEITEMLOADING', false);
          commit('REMOVEITEMID', null);
          commit('REMOVEITEMERROR', false);
          commit('SHOW_BASKET', true);
          if (rootState?.order?.order) {
            dispatch(
              'notification/notifySuccess',
              {
                message: `Item removed. <br class="d-block d-md-none" /><a href="${rootGetters.generateFullUrl(
                  '/basket'
                )}" class="text-primary">View Basket</a> | <a href="${rootGetters.generateFullUrl(
                  `/order/${orderId}/checkout`
                )}" class="text-primary">Checkout</a>`,
                options: {
                  family: 'AddItem',
                  dismissSecs: 5,
                  dismissible: true,
                  isHtmlMessage: true,
                  class: 'text-center',
                  text: { class: 'text-secondary' },
                  $callback: {
                    generateFullUrl: rootGetters.generateFullUrl,
                    order: rootState?.order?.order,
                    notifySuccess: vm.notifySuccess,
                  },
                  callback: function ({ order, generateFullUrl, notifySuccess }) {
                    if (order.itemsCount > 0)
                      notifySuccess(
                        `${order.itemsCount} ${order.itemsCount > 1 ? 'Items' : 'Item'}. <a href="${generateFullUrl(
                          '/basket'
                        )}" class="text-primary"><u>View Basket</u></a> | <a href="${generateFullUrl(
                          `/order/${orderId}/checkout`
                        )}" class="text-primary"><u>Checkout</u></a>`,
                        {
                          family: 'AddItem',
                          icon: null,
                          dismissSecs: -1,
                          dismissible: true,
                          isHtmlMessage: true,
                          class: 'text-center',
                          text: { class: 'text-secondary' },
                        }
                      );
                  },
                },
              },
              { root: true }
            ).then(() => {
              if (rootState?.order?.order?.itemsCount === 0) setTimeout(() => commit('SHOW_BASKET', false), 3000);
            });
          }
          resolve(response);
        })
        .catch((error) => {
          commit('REMOVEITEMLOADING', false);
          commit('REMOVEITEMERROR', error?.message?.[0]?.message);
          commit('LOADING', false);
          const notification = {
            type: 'warning',
            message: 'There was a problem removing your item',
          };
          dispatch('notification/add', notification, { root: true });
          reject(error);
        })
    );
  },
  addItemOrPersonalization(
    { commit, dispatch, rootState, rootGetters },
    { vm, orderId, itemId, productDetails, personalization, data, discountCode, changingDiscount }
  ) {
    commit('ADDITEMLOADING', true);
    commit('ADDITEMID', itemId);
    const dispatchAction = () =>
      new Promise((resolve, reject) => {
        rootState?.orderId || orderId
          ? OrderService[!personalization ? 'addItem' : 'addPersonalization']?.(
              orderId,
              !personalization ? productDetails : { personalization, itemId }
            )
              .then(resolve)
              .catch(reject)
          : dispatch('createLocalOrder', { cityId: vm.cityId, data, discountCode, changingDiscount }).then(resolve).catch(reject);
      });
    return new Promise((resolve, reject) =>
      dispatchAction()
        .then((response) => {
          commit('order/SET_ORDER', response, { root: true });
          commit('ADDITEMLOADING', false);
          commit('ADDITEMID', null);
          commit('ADDITEMERROR', false);
          commit('SHOW_BASKET', true);
          if (rootState?.order?.order) {
            dispatch(
              'notification/notifySuccess',
              {
                message: `Item added. <br class="d-block d-md-none" /><a href="${rootGetters.generateFullUrl(
                  '/basket'
                )}" class="text-primary">View Basket</a> | <a href="${rootGetters.generateFullUrl(
                  `/order/${orderId}/checkout`
                )}" class="text-primary">Checkout</a>`,
                options: {
                  family: 'AddItem',
                  dismissSecs: 5,
                  dismissible: true,
                  isHtmlMessage: true,
                  class: 'text-center',
                  text: { class: 'text-secondary' },
                  $callback: {
                    generateFullUrl: rootGetters.generateFullUrl,
                    order: rootState?.order?.order,
                    notifySuccess: vm.notifySuccess,
                  },
                  callback: function ({ order, generateFullUrl, notifySuccess }) {
                    if (order.itemsCount > 0)
                      notifySuccess(
                        `${order.itemsCount} ${order.itemsCount > 1 ? 'Items' : 'Item'}. <a href="${generateFullUrl(
                          '/basket'
                        )}" class="text-primary"><u>View Basket</u></a> | <a href="${generateFullUrl(
                          `/order/${orderId}/checkout`
                        )}" class="text-primary"><u>Checkout</u></a>`,
                        {
                          family: 'AddItem',
                          icon: null,
                          dismissSecs: -1,
                          dismissible: true,
                          isHtmlMessage: true,
                          class: 'text-center',
                          text: { class: 'text-secondary' },
                        }
                      );
                  },
                },
              },
              { root: true }
            ).then(() => {
              if (rootState?.order?.order?.itemsCount === 0) setTimeout(() => commit('SHOW_BASKET', false), 3000);
            });
          }
          resolve(response);
        })
        .catch((error) => {
          commit('ADDITEMLOADING', false);
          commit('ADDITEMERROR', error?.message?.[0]?.message);
          commit('LOADING', false);
          const notification = {
            type: 'warning',
            message: 'There was a problem adding your item',
          };
          dispatch('notification/add', notification, { root: true });
          reject(error);
        })
    );
  },
  cancelOrder({ commit, dispatch }, orderId) {
    commit('LOADING', true);
    OrderService.cancelOrder(orderId)
      .then((response) => {
        commit('SHOW_BASKET', false);
        commit('order/SET_ORDER', response, { root: true });
        dispatch(
          'notification/notifySuccess',
          {
            message: `Order cancelled.`,
            options: {
              family: 'AddItem',
              overrideDuplicate: true,
              icon: null,
              dismissSecs: 5,
              dismissible: true,
              isHtmlMessage: false,
              class: 'text-center',
              text: { class: 'text-secondary' },
            },
          },
          { root: true }
        );
        return Promise.resolve();
      })
      .catch((error) => {
        error.location = 'cancelOrder';
        console.error(error);

        const notification = {
          type: 'danger',
          message: error.message,
        };
        dispatch('notification/add', notification, { root: true });

        return Promise.reject();
      })
      .finally(() => commit('LOADING', false));
  },
  showBasket({ commit }, showBasket) {
    commit('SHOW_BASKET', showBasket);
  },
  removeItemsByProduct(
    { commit, dispatch, rootState, rootGetters },
    { vm, orderId, itemId, productId, data, discountCode, changingDiscount, quantity }
  ) {
    commit('REMOVEITEMLOADING', true);
    commit('REMOVEITEMID', itemId);
    const dispatchAction = () =>
      new Promise((resolve, reject) =>
        (rootState?.orderId || orderId
          ? OrderService.removeItemsByProduct(orderId, productId, quantity)
          : dispatch('createLocalOrder', {
              cityId: vm.cityId,
              data,
              discountCode,
              changingDiscount,
            })
        )
          .then(resolve)
          .catch(reject)
      );
    return new Promise((resolve, reject) =>
      dispatchAction()
        .then((response) => {
          commit('order/SET_ORDER', response, { root: true });
          commit('REMOVEITEMLOADING', false);
          commit('REMOVEITEMID', null);
          commit('REMOVEITEMERROR', false);
          commit('SHOW_BASKET', true);
          if (rootState?.order?.order) {
            dispatch(
              'notification/notifySuccess',
              {
                message: `All items removed. <br class="d-block d-md-none" /><a href="${rootGetters.generateFullUrl(
                  '/basket'
                )}" class="text-primary">View Basket</a> | <a href="${rootGetters.generateFullUrl(
                  `/order/${orderId}/checkout`
                )}" class="text-primary">Checkout</a>`,
                options: {
                  family: 'AddItem',
                  dismissSecs: 5,
                  dismissible: true,
                  isHtmlMessage: true,
                  class: 'text-center',
                  text: { class: 'text-secondary' },
                  $callback: {
                    generateFullUrl: rootGetters.generateFullUrl,
                    order: rootState?.order?.order,
                    notifySuccess: vm?.notifySuccess,
                  },
                  callback: function ({ order, generateFullUrl, notifySuccess }) {
                    if (order.itemsCount > 0)
                      notifySuccess(
                        `${order.itemsCount} ${order.itemsCount > 1 ? 'Items' : 'Item'}. <a href="${generateFullUrl(
                          '/basket'
                        )}" class="text-primary"><u>View Basket</u></a> | <a href="${generateFullUrl(
                          `/order/${orderId}/checkout`
                        )}" class="text-primary"><u>Checkout</u></a>`,
                        {
                          family: 'AddItem',
                          icon: null,
                          dismissSecs: -1,
                          dismissible: true,
                          isHtmlMessage: true,
                          class: 'text-center',
                          text: { class: 'text-secondary' },
                        }
                      );
                  },
                },
              },
              { root: true }
            ).then(() => {
              if (rootState?.order?.order?.itemsCount === 0) setTimeout(() => commit('SHOW_BASKET', false), 3000);
            });
          }
          resolve(response);
        })
        .catch((error) => {
          commit('REMOVEITEMLOADING', false);
          commit('REMOVEITEMERROR', error?.message?.[0]?.message);
          commit('LOADING', false);
          const notification = {
            type: 'warning',
            message: 'There was a problem removing your items',
          };
          dispatch('notification/add', notification, { root: true });
          reject(error);
        })
    );
  },
};

export const getters = {
  getPets: (state, getters, rootState) => {
    let pets = [];
    if (rootState?.order?.order?.id) {
      rootState?.order?.order?.petOwner?.pets?.forEach((pet) => {
        if (
          rootState?.order?.order?.items?.find(
            (item) =>
              item.group.pet &&
              item.group.pet.id == pet.id &&
              !item.product.name.includes('Voice & Sight') &&
              !item.product.name.includes('V&S')
          )
        ) {
          pets.push(pet);
        }
      });
    }
    return pets;
  },
  getSections: (state, getters, rootState) => {
    let sections = {
      pets: {},
      donations: [],
      additional: [],
      essentials: [],
      miscellaneous: [],
      walletCardConfigurations: [],
      vs: {
        pet: [],
        petOwner: [],
      },
      petTrackingDevices: [],
    };

    if (rootState?.order?.order?.id) {
      let seen = [];

      getters.getPets?.forEach((pet) => {
        sections.pets[pet.id] = {
          licenses: [],
          replacements: [],
          tags: [],
          collars: [],
          walletcards: [],
          petTrackingDevices: []
        };
      });

      rootState?.order?.order?.items?.forEach((item) => {
        if (!seen.includes(item.id)) {
          seen.push(item.id);
          if (item.product && ['WALLET_CARD'].includes(item.product.type) && item?.group?.pet?.id) {
            if (item.children?.length >= 0 && !item.parent) {
              sections.pets[item.group.pet.id]?.walletcards.push(item);
            }
          } else if (item.product && ['SUBSCRIPTION'].includes(item.product.type)) {
            // Javascript doesn't have a `break;` or `continue;`
            // The subscription is handled as a child of the Pet Tracking Device.
            // We do not want to include this product as a standalone order item
            // else we will be displaying duplicates in the UI.
          } else if (item.product && ['PET_TRACKING_DEVICE'].includes(item.product.type)) {
            sections.pets[item.group.pet.id]?.petTrackingDevices.push(item);
          } else if (item.product.name.includes('Voice & Sight') || item.product.name.includes('V&S')) {
            if (item.product.type === 'REPLACEMENT_TAG' || item.product.type === 'PET_TAG') {
              sections.vs.pet.push(item);
            } else if (item.product.type === 'VOICE_AND_SIGHT') {
              sections.vs.petOwner.push(item);
            }
          } else if (item.product && ['LICENCE', 'LATE_FEE'].includes(item.product.type)) {
            sections.pets[item.group.pet.id].licenses.push(item);
          } else if (item.product && ['PET_TAG', 'DESIGNER_TAG'].includes(item.product.type) && item.group.pet) {
            sections.pets[item.group.pet.id].tags.push(item);
            item.children?.forEach((child) => {
              seen.push(child.id);
            });
          } else if (item.product && ['COLLAR'].includes(item.product.type) && item?.group?.pet?.id) {
            sections.pets[item.group.pet.id]?.collars.push(item);
          } else if (item.product && item.product.type === 'DONATION') {
            sections.donations.push(item);
          } else if (item.product && item.product.type === 'REPLACEMENT_TAG') {
            sections.pets[item.group.pet.id].replacements.push(item);
          } else if (item.product && item.product?.type === 'PET_ESSENTIALS' && !item.parent) {
            // COMBINE QUANTITY
            const existingItemIndex = sections.essentials.findIndex((prod) => prod.product.id === item.product.id);
            if (existingItemIndex !== -1 && item.product?.type === 'PET_ESSENTIALS') {
              sections.essentials[existingItemIndex].product.quantity++;
              sections.essentials[existingItemIndex].product.totalQtyPrice += item.product.price;
              sections.essentials[existingItemIndex].product.totalQtyDiscountedPrice += Number(item.subtotal - item.discount);
            } else {
              item.product.quantity = 1;
              item.product.totalQtyPrice = item.product.price;
              item.product.totalQtyDiscountedPrice = Number(item.subtotal - item.discount);
              sections.essentials.push(item);
            }
          } else if (item.product && item.product.type === 'ADDITIONAL_FEE') {
            if (item.product?.subType === 'pet' && item.group?.pet?.id) {
              sections.pets[item.group.pet.id].licenses.push(item);
            } else {
              item.product.quantity = 1;
              item.product.totalQtyPrice = item.product.price;
              item.product.totalQtyDiscountedPrice = Number(item.subtotal - item.discount);
              sections.additional.push(item);
            }
          } else {
            if (item.parent) {
              return;
            }
            item.product.quantity = 1;
            item.product.totalQtyPrice = item.product.price;
            item.product.totalQtyDiscountedPrice = Number(item.subtotal - item.discount);
            sections.miscellaneous.push(item);
          }
        }
      });

      // Add wallet card configurations for groups without pets
      rootState?.order?.order?.groups
      ?.filter((group) => !group.pet && group.walletCardConfigurations)
      ?.forEach((group) => sections.walletCardConfigurations.push(...group.walletCardConfigurations?.filter((config) => config?.optedIn)));
    } else if (rootState?.order?.order) {
      rootState?.order?.order?.items?.forEach((item) => {
        if (!item.parent) {
          if (item.product.type !== 'PET_ESSENTIALS') {
            if (['COLLAR', 'LEASH'].includes(item.product.type)) {
              item.product.quantity = 1;
              item.product.totalQtyPrice = Number(item.product.price);
              item.product.totalQtyDiscountedPrice = Number(item.subtotal - item.discount);
            }
            sections.miscellaneous.push(item);
          } else {
            let existingItemIndex = sections.miscellaneous.findIndex((prod) => prod.product.id === item.product.id);
            if (existingItemIndex != -1) {
              sections.miscellaneous[existingItemIndex].product.quantity++;
              sections.miscellaneous[existingItemIndex].product.totalQtyPrice += item.product.price;
              sections.miscellaneous[existingItemIndex].product.totalQtyDiscountedPrice += Number(item.subtotal - item.discount);
            } else {
              item.product.quantity = 1;
              item.product.totalQtyPrice = item.product.price;
              item.product.totalQtyDiscountedPrice = Number(item.subtotal - item.discount);
              sections.miscellaneous.push(item);
            }
          }
        }
      });
    }
    return sections;
  },
  renewalPetsInOrder: (state, getters, rootState) =>
    rootState?.order?.order?.petOwner?.renewalPets?.filter((renewalPet) => getters.getSections?.pets[renewalPet?.id]?.licenses.length == 0),
};
